__turbopack_context__.v({
  "box": "ratesTableList-module-scss-module__I8zi-q__box",
  "card": "ratesTableList-module-scss-module__I8zi-q__card",
  "cta": "ratesTableList-module-scss-module__I8zi-q__cta",
  "itemTitle": "ratesTableList-module-scss-module__I8zi-q__itemTitle",
  "period": "ratesTableList-module-scss-module__I8zi-q__period",
  "radio": "ratesTableList-module-scss-module__I8zi-q__radio",
  "selectedBox": "ratesTableList-module-scss-module__I8zi-q__selectedBox",
  "white": "ratesTableList-module-scss-module__I8zi-q__white",
  "wrapper": "ratesTableList-module-scss-module__I8zi-q__wrapper",
});
